import { render, staticRenderFns } from "./utilisateur-avatar-update.vue?vue&type=template&id=2b92d9ad"
import script from "./utilisateur-avatar-update.vue?vue&type=script&lang=js"
export * from "./utilisateur-avatar-update.vue?vue&type=script&lang=js"
import style0 from "./utilisateur-avatar-update.vue?vue&type=style&index=0&id=2b92d9ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports